export const Z_INDEXES = {
  ServiceDeskMenu: 2,
  ServiceDeskConversations: 1,
  ServiceDeskConversation: 2,
  ServiceDeskConversationDetails: 3,
  ServiceDeskConversationHeader: 4,
  loader: 1000,
  popper: 2000,
} as const;
